import { Injectable, inject } from '@angular/core';
import { Route, Router } from '@angular/router';

import { routes } from '../app-routing.module';
import { RouteDataModel } from '../models/core/route-data.model';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class RouteService {
    private readonly authService = inject(AuthService);
    private readonly router = inject(Router);

    getRouteData(route: Route): RouteDataModel {
        let routeData = new RouteDataModel();

        if (!!route) {
            if (!!(route.data as RouteDataModel)) {
                routeData = route.data as RouteDataModel;
            }
            routeData.path = route.path ?? '';
        }

        return routeData;
    }

    generateMenu(childRoutes?: Route[], parent?: RouteDataModel): RouteDataModel[] {
        const localRoutes = childRoutes || routes;
        const routesModel: RouteDataModel[] = [];

        localRoutes
            .filter(r => !!r.data && (r.data['showInMenu'] || r.data['showChildrenInMenu']))
            .forEach(r => {
                if (!!r.data!['commandName'] && !this.authService.hasPermission(r.data!['commandName'])) {
                    return;
                }

                if (!!r.data!['commandNames'] && !this.authService.hasAnyPermission(r.data!['commandNames'])) {
                    return;
                }

                if (r.data!['isSection']) {
                    const parentSection = new RouteDataModel({
                        path: r.path
                    });
                    this.generateMenu(r.children, parentSection).forEach(route => routesModel.push(route));
                } else if (r.data!['showAsParentMenu']) {
                    const parentMenu = new RouteDataModel({
                        path: r.path,
                        icon: r.data!['icon'],
                        title: r.data!['title'],
                        isParentForSubMenu: true
                    });
                    parentMenu.children = this.generateMenu(r.children, parentMenu);

                    routesModel.push(parentMenu);
                } else if (r.data!['showAsSubMenu']) {
                    const subMenuItem = new RouteDataModel({
                        parent,
                        path: r.path,
                        title: r.data!['title'],
                        isSubMenu: true
                    });
                    routesModel.push(subMenuItem);
                } else if (r.path || r.data!['showInMenu']) {
                    const data = new RouteDataModel({
                        class: r.data!['class'],
                        icon: r.data!['icon'],
                        title: r.data!['title'],
                        path: r.path,
                        parent
                    });

                    if (r.data!['showChildrenInMenu']) {
                        data.children = this.generateMenu(r.children, data);
                    }

                    routesModel.push(data);
                } else if (r.data!['showChildrenInMenu']) {
                    this.generateMenu(r.children).forEach(child => {
                        routesModel.push(child);
                    });
                }
            });

        return routesModel;
    }

    reloadPage(removeQueryParameters = false): void {
        const promise = removeQueryParameters ? this.removeQueryParameters() : Promise.resolve();
        promise.then(() => window.location.reload());
    }

    removeQueryParameters(): Promise<boolean> {
        return this.router.navigate([], { queryParams: undefined });
    }
}
